/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentPage
 */
export interface PaymentPage {
    /**
     * 
     * @type {string}
     * @memberof PaymentPage
     */
    value: string;
}

/**
 * Check if a given object implements the PaymentPage interface.
 */
export function instanceOfPaymentPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PaymentPageFromJSON(json: any): PaymentPage {
    return PaymentPageFromJSONTyped(json, false);
}

export function PaymentPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function PaymentPageToJSON(value?: PaymentPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

